/**
 * Design tokens cho dashboard Cashflows — theo design
 * `plan/report/erp-report-cash.jsx` ("TLC ERP · Management Report" v1):
 * bảng header forest chữ trắng, số IBM Plex Mono tabular, band section
 * vàng nhạt / summary xanh nhạt, số âm ngoặc đỏ. Token RPT.* của design
 * map về brand TLC (theme forest #0b3633, muted gold) — co-locate riêng
 * page này, KHÔNG đụng tokens dashboard PnL.
 */
export const RPT = {
  forest: '#0b3633', // header bảng (TLC.forest — đồng bộ topbar/brand)
  ink: '#1a1a1a', // chữ chính / số dương
  sub: '#5f6b76', // chữ phụ (unit, subtitle, label indent)
  axis: '#8a949e', // số rỗng "—" / caption mờ
  grid: '#e8ecef', // kẻ ngang dòng
  border: '#dfe3e8', // viền card + bảng
  rose: '#d32f2f', // số âm (đồng bộ negative toàn dashboard)
  gold: '#b28a3b', // accent premium (brand muted gold) — caption ngày snapshot
  /** Band tiêu đề section "A./B. Cash flows from ..." (full-row). */
  sectionBg: '#fbeed1',
  sectionText: '#8b5a00',
  sectionBorder: '#f0d896',
  /** Band subsection "Cash Inflows/Outflows" (full-row, nghiêng). */
  subsectionBg: '#fdf6e8',
  subsectionText: '#6b5b3f',
  subsectionBorder: '#f6e6c8',
  /** Hàng tổng Cash/Closing Surplus + hàng isTotal bảng nhỏ. */
  summaryBg: '#e8f1ee',
  /** Hàng Opening Surplus (nghiêng, nền xám rất nhạt). */
  openingBg: '#fafbfc',
} as const

/** Font design (load ở index.html, fallback Inter/system khi offline). */
export const FONT_SANS = "'IBM Plex Sans', 'Inter', system-ui, sans-serif"
export const FONT_MONO = "'IBM Plex Mono', ui-monospace, SFMono-Regular, Menlo, monospace"
